import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useParams } from 'react-router';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@etchteam/diamond-ui/composition/Grid/Grid';
import '@etchteam/diamond-ui/composition/Grid/GridItem';
import '@/components/composition/Layout/Layout';
import '@/components/composition/Header/Header';
import '@/components/canvas/ContextHeader/ContextHeader';
import '@/components/canvas/Tip/Tip';
import '@/components/composition/Wrap/Wrap';
import '@/components/content/HeaderTitle/HeaderTitle';
import '@/components/content/Icon/Icon';
export default function MaterialLayout() {
    const { t } = useTranslation();
    const { postcode } = useParams();
    return (_jsxs("locator-layout", { children: [_jsxs("locator-header", { slot: "layout-header", children: [_jsx("locator-header-logo", { children: _jsx(Link, { to: `/${postcode}`, children: _jsx("locator-logo", { type: "logo-only" }) }) }), _jsx("locator-header-content", { children: _jsxs("locator-header-title", { children: [_jsx("diamond-button", { children: _jsx(Link, { to: `/${postcode}`, children: _jsx("locator-icon", { icon: "arrow-left", label: "Back" }) }) }), _jsxs("div", { children: [_jsx("h2", { children: t('material.title') }), _jsx("p", { children: postcode })] })] }) })] }), _jsx(Outlet, {})] }));
}
